export const LANGUAGE = {
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  'zh-Hant': 'zh-Hant',
  es: 'es',
  pt: 'pt',
  de: 'de',
  fr: 'fr',
  ru: 'ru',
  th: 'th'
};

export const LANGUAGE_CONFIGS = [
  {
    key: LANGUAGE['en'],
    name: 'ENGLISH'
  },
  {
    key: LANGUAGE['ja'],
    name: '日本語'
  },
  {
    key: LANGUAGE['ko'],
    name: '한국어'
  },
  {
    key: LANGUAGE['zh-Hant'],
    name: '繁體中文'
  },
  {
    key: LANGUAGE['es'],
    name: 'ESPAÑOL'
  },
  {
    key: LANGUAGE['pt'],
    name: 'PORTUGUÊS'
  },
  {
    key: LANGUAGE['de'],
    name: 'DEUTSCH'
  },
  {
    key: LANGUAGE['fr'],
    name: 'FRANÇAIS'
  },
  {
    key: LANGUAGE['ru'],
    name: 'РУССКИЙ'
  },
  {
    key: LANGUAGE['th'],
    name: 'ไทย'
  }
];
